<template lang="html">
  <div>
    <div v-show="error">
      <!-- Error -->
      <p class="alert alert-danger">Error: {{ errorMessage }}</p>
    </div>
    <div>
      <!-- No error. -->
      <b-row v-if="show_obj">
        <b-col md="6">
          <DirectoryPlayer v-if="show_obj.blobsLoaded" :show="show_obj" />
        </b-col>
        <b-col>
          <div v-if="enabled">
            <h3>{{ show_obj.info.title }}</h3>
            <p>Slides: {{ show_obj.info.slide_count }}</p>
            <p>
              Average image file size:
              {{ show_obj.averageImageSize | humanFileSize }}
            </p>

            <p v-if="possibleDuplicate">
              <mark class="small">
                <v-icon name="copy" /> This show is a duplicate of another
                selected show. <br />
                This version may contain smaller source images.
              </mark>
            </p>

            <p>
              Last edited:
              <span v-if="show_obj.info.timestamp">
                {{ (show_obj.info.timestamp / 1000) | date_string_short }}
              </span>
              <span v-else>
                Unknown
              </span>
            </p>

            <p v-if="show_obj.info.duration > 1">
              Duration: {{ (show_obj.info.duration * 1000) | toMMSS }}
            </p>

            <b-button
              size="lg"
              variant="primary"
              :disabled="!enabled"
              @click="beginUpload"
            >
              Begin upload
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import DirectoryPlayer from "@/components/DirectoryPlayer/DirectoryPlayer";
export default {
  name: "ZipPreview",
  components: {
    DirectoryPlayer
  },
  filters: {
    toMMSS: function(s) {
      // Pad to 2 or 3 digits, default is 2
      function pad(n, z) {
        z = z || 2;
        return ("00" + n).slice(-z);
      }

      var ms = s % 1000;
      s = (s - ms) / 1000;
      var secs = s % 60;
      s = (s - secs) / 60;
      var mins = s % 60;

      return pad(mins) + ":" + pad(secs);
    },

    date_string_short: function(value) {
      value = value * 1000;
      return format(new Date(value), "MMMM d, yyyy");
    },
    humanFileSize: function(bytes, si = true, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );

      return bytes.toFixed(dp) + " " + units[u];
    }
  },
  props: {
    show_obj: {
      type: Object,
      default: () => {}
    },
    callback: {
      type: Function,
      default: function() {}
    },
    possibleDuplicate: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      enabled: true,
      error: false,
      errorMessage: "",
      zipShowInfo: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    loaded(obj) {
      console.log("loaded", obj.info);
      this.error = false;
      this.enabled = true;
      this.zipShowInfo = obj.info;
    },
    onError(msg) {
      console.log("onError", msg);
      this.error = true;
      this.errorMessage = msg;
      this.enabled = false;
    },
    beginUpload() {
      this.callback(this.show_obj);
      this.enabled = false;
    }
  }
};
</script>

<style lang="css" scoped></style>
